module.exports = __webpack_public_path__ + "static/media/11.bfcf19a7.png";